/**
 * Composite organisationCategory UI values that expand to multiple indexed Lucene
 * strings for OrganisationCategory:(...) in search.js orgCategoryFormat.
 */

/** Exact tree `value` / Redux token (spaces around `/`). */
export const ANALYTICAL_INSTRUMENTS_LIFE_SCIENCE_TOOLS_UI =
  'Analytical Instruments / Life Science Tools';

/** Indexed Solr values emitted for that UI row. */
export const ANALYTICAL_INSTRUMENTS_LIFE_SCIENCE_TOOLS_INDEXED = Object.freeze([
  'Analytical Instruments',
  'Life Science Tools',
]);

/**
 * If `item` is a registered composite UI token, returns the Lucene-side fragments
 * to append (with exclude wrapping). Otherwise returns null (caller keeps default path).
 *
 * @param {string} item getStringValue(filter entry)
 * @param {boolean} excluded isExcluded(filter entry)
 * @param {(s: string) => string} toExcluded
 * @returns {string[] | null}
 */
export function expandLucenePartsForOrganisationCategoryItem(
  item,
  excluded,
  toExcluded
) {
  if (item !== ANALYTICAL_INSTRUMENTS_LIFE_SCIENCE_TOOLS_UI) {
    return null;
  }
  return ANALYTICAL_INSTRUMENTS_LIFE_SCIENCE_TOOLS_INDEXED.map(label =>
    excluded ? toExcluded(label) : label
  );
}
